import { render, staticRenderFns } from "./PlayerGrid.vue?vue&type=template&id=39f39db3&"
import script from "./PlayerGrid.vue?vue&type=script&lang=ts&"
export * from "./PlayerGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports